<template>
  <div
    class="tw-flex tw-items-center tw-py-6 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light tw-px-6"
  >
    <div
      class="tw-flex tw-items-center"
      :style="`width: ${columns[0].width}`"
    >
      <i-badge :type="company.is_active ? 'success' : 'default'">
        {{ company.is_active ? $t('common.values.yes') : $t('common.values.no') }}
      </i-badge>
    </div>

    <div :style="`width: ${columns[1].width}`">
      {{ company.fullname }}
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      :style="`width: ${columns[2].width}`"
    >
      {{ company.short_name }}
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      :style="`width: ${columns[3].width}`"
    >
      {{ company.client_companies.length }}
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      :style="`width: ${columns[4].width}`"
    >
      {{ company.contacts }}
    </div>

    <div :style="`width: ${columns[5].width}`">
      {{ company.address_city }}
    </div>

    <div :style="`width: ${columns[6].width}`">
      <div
        class="tw-flex tw-items-center tw-gap-2"
      >
        <i-button
          type="white"
          is-icon
          @click="isEditCompanyDialogOpen = true"
        >
          <icon-edit />
        </i-button>
        <i-confirm-popover
          :cancel-text="$t('common.actions.cancel')"
          :submit-text="$t('common.actions.delete')"
          @submit="deleteCompany"
        >
          <template #reference>
            <i-button
              type="white"
              is-icon
              class="tw-text-primary"
              :is-loading="isDeleting"
            >
              <icon-trash />
            </i-button>
          </template>
          <template #content>
            <div>
              {{ $t('adm.companies.delete_company_dialog.confirm_text') }}
              {{ companyLabel }}
            </div>
          </template>
        </i-confirm-popover>
      </div>
    </div>
    <EditAgencyCompanyDialog
      :is-open="isEditCompanyDialogOpen"
      :company-id="company.id"
      @close="isEditCompanyDialogOpen = false"
    />
  </div>
</template>

<script>
import EditAgencyCompanyDialog from '@/components/Administration/Agency/Companies/EditAgencyCompanyDialog.vue';
import { companiesTableColumns } from '@/components/Administration/Agency/Companies/constants';
import { getValidationError } from '@/helpers';

export default {
  name: 'AgencyCompaniesListItem',
  components: { EditAgencyCompanyDialog },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isEditCompanyDialogOpen: false,
      isDeleting: false,
    };
  },
  computed: {
    companyLabel() {
      if (this.company.short_name != null && this.company.short_name !== '') {
        return this.company.short_name;
      }
      return this.company.fullname;
    },
    columns() {
      return companiesTableColumns;
    },
  },

  methods: {
    async deleteCompany() {
      this.isDeleting = true;
      try {
        await this.$store.dispatch('v2/admin/cms/agency/companies/deleteCompany', this.company.id);
      } catch (e) {
        this.$message.error({
          message: e.response.data.message,
          showClose: true,
          dangerouslyUseHTMLString: true,
        });
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
